import { useEffect, useRef } from 'react';

import { socketClient } from '../socketClient';

import { subscribeWhenConnected } from '../utils/subscribeWhenConnected';

import { usePrintService } from '../../hooks/printing/usePrintService';

interface Props {
  enabled: boolean;
}

export const useSalesPrintSubscription = ({
  enabled,
}: Props) => {

  const { requestLegacyPrint } = usePrintService();

  const requestLegacyPrintRef = useRef(requestLegacyPrint);
  requestLegacyPrintRef.current = requestLegacyPrint;

  const subscribedRef = useRef(false);

  const subscriptionRef = useRef<any>(null);

  useEffect(() => {

    if (!enabled) {
      return;
    }

    if (subscribedRef.current) {
      return;
    }

    const stopWaiting = subscribeWhenConnected(() => {

      if (subscribedRef.current) {
        return;
      }

      subscribedRef.current = true;

      subscriptionRef.current = socketClient.subscribe(

        '/topic/sales/print',

        (message) => {

          if (!message.body) {
            return;
          }

          try {

            const payload =
              JSON.parse(message.body);

            console.log(
              '🖨️ PRINT:',
              payload
            );

            if (!payload.allowPrint) {
              return;
            }

            void requestLegacyPrintRef.current(payload.type, payload.documentId).catch(() => undefined);

          } catch (error) {

            console.error(
              '❌ Error print subscription:',
              error
            );
          }
        }
      );

      console.log(
        '✅ Subscription print registrada'
      );
    });

    return () => {

      subscriptionRef.current?.unsubscribe();
      stopWaiting?.();

      subscribedRef.current = false;

      console.log(
        '🛑 Subscription print removida'
      );
    };

  }, [enabled]);
};
